import { IconProps } from "@/data/types"

export default function FacebookIcon({ width=10, height=20, color='#A58760', className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M6.821 20V11H9.554L10 7H6.821V5.052C6.821 4.022 6.848 3 8.287 3H9.745V0.14C9.745 0.0970003 8.492 0 7.225 0C4.58 0 2.923 1.657 2.923 4.7V7H0V11H2.923V20H6.821Z" fill={color}/>
      </svg>
    </div>
  )
}